import { render, staticRenderFns } from "./BrantDetails.vue?vue&type=template&id=5eb2df3d&"
import script from "./BrantDetails.vue?vue&type=script&lang=ts&"
export * from "./BrantDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports